import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate } from "react-router-dom";

const isRouteActive = (pathname, href) =>
  !!href &&
  (href === "/"
    ? pathname === "/"
    : pathname === href || pathname.startsWith(href + "/"));

const MenuItem = ({ icon, text, href, clickEvent, setRefresh }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = isRouteActive(location.pathname, href);

  const handleClick = (e) => {
    e.preventDefault();
    clickEvent?.();
    if (href) {
      document.getElementById("sidebar")?.classList.remove("active");
      navigate(href);
      setRefresh?.((r) => !r);
    }
  };

  return (
    <li className={isActive ? "active-menu-item" : ""}>
      <a href={href || "/#"} onClick={handleClick}>
        <FontAwesomeIcon icon={icon} />
        <span className="links_name">{text}</span>
      </a>
    </li>
  );
};

export default MenuItem;
